module.exports = __webpack_public_path__ + "static/media/nylas-loading.3b688f4d.svg";